import { TaxApiParam } from './tax';

export class FGProductId{
  public ProductId:number;
  constructor(){
    this.ProductId = 0;
  }
}


export class ProductSearchParam {
  public ProdSegmentId:number;
  public ProductGroupId:number;
  public ProductId:number;
  public ProductCode:string;
  public AdvanceGroupId:number;
  public WarrantyMonth:number;
  public FGProductId:FGProductId[];
  constructor(){
    this.ProdSegmentId = 0 ;
    this.ProductGroupId = 0 ;
    this.ProductId = 0 ;
    this.ProductCode = "" ;
    this.AdvanceGroupId = 0;
    this.WarrantyMonth = 0
    this.FGProductId = [];
  }
}

export class ProductSegment {
  public ProdSegmentId: number;
  public ProdSegmentCode: string;    
  public ProdSegmentDesc: string;
  constructor() {
    this.ProdSegmentId = 0;
    this.ProdSegmentCode = "";
    this.ProdSegmentDesc = "";
  }
}  

export class Product extends ProductSegment {
    public ProductId: number;
    public ProductCode: string;    
    public ProductDesc: string;
    constructor() {
      super();
      this.ProductId = 0;
      this.ProductCode = "";
      this.ProductDesc = "";     
    }
  }  

export class OpsProduct  {
    // public Group: string;
    // public Grade: string;
    public Quantity: number;
    public Price: number;
    public Total: number;
    // public TotalWithTax?: number;
    public IsNewRow?: boolean = false;
    public SelectedProduct:any;

    //added by swati on 26/03/2021
    public PriceList?: number;
    public WorkSheetNSP?: number;
    public WorkSheetLanded?: number;
    public BookingLanded?: number;   
    public PId:number;
    public gID:string;
    public pQty:number;

    //added by swati on 18/5/2021 - to get unit cost on rental product 
    public UnitWSCost: number;
    public UnitSalePrice: number;
    public SaleAmount: number;
    public CostAmount:number;
    constructor(){
        // this.Group = "";
        // this.Grade = "";
        this.Quantity = 0;
        this.Price = 0;
        this.Total = 0;
        // this.TotalWithTax = 0
        this.IsNewRow = false;
        this.PriceList=0;
        this.WorkSheetNSP=0;
        this.WorkSheetLanded=0;
        this.BookingLanded=0;
        this.PId=0;
        this.gID="";
        this.pQty=0;
        this.UnitWSCost=0;
        this.UnitSalePrice=0;
        this.SaleAmount=0;
        this.CostAmount = 0;
    }
}


export class Counter{
  public CounterId:number;
  public TechnicalId?:number;
  public CounterDesc:string;
  public ProductList:Array<number>;
  public Qty:number;
  public ExistingCSARate:string;
  constructor(){
    this.CounterId = 0;
    this.CounterDesc = "";
    this.ExistingCSARate = "";
    this.ProductList = new Array<number>();
    this.Qty = 0;
  }
}


export class OpsPartParams {    
  public TaxApiParam: TaxApiParam;
  constructor(
  ) {
      this.TaxApiParam = new TaxApiParam();
  }
}




export class GetSpraPriceParam {    
  ProductId:number
  PriceListTypeCode?:string; 
  PriceType?:string;
  IsJson:boolean;
  constructor(
  ) {
    this.ProductId = 0;
    this.IsJson = true;
  }
}



export class ProductGroup {
  public ProductGroupId: number;
  public ProductGroupDesc: string;
  constructor() {
    this.ProductGroupId = 0;
    this.ProductGroupDesc = "";
  }
}  

//Added by Rahul Kumar on 26/08/2022 [To summarize the data being sent to the API to get Distance wise FG Count]
export class ConsigneeSummary{
  public DistanceID: number;
  public ProductDetails: Array<ConsigneeProductSummary>;
  constructor(){
    this.DistanceID = 0;
    this.ProductDetails = new Array<ConsigneeProductSummary>();
  }
}

//Added by Rahul Kumar on 26/08/2022 [To summarize the data being sent to the API to get Distance wise FG Count]
export class ConsigneeProductSummary{
  public Quantity: number;
  public ProductId: number;
  constructor(){
    this.Quantity = 0;
    this.ProductId = 0;
  }
}